export default {
  overview: {
    title: "Vue d'ensemble",
    todayIncome: "Chiffre du jour",
    yesterdayIncome: "Chiffre d'hier",
    platformIncome: "Revenu plateforme estimé",
    riderIncome: "Revenu livreurs estimé",
    shopRecharge: "Recharge marchands",
    shopRechargeAmount: "Recharge marchands",
    rewardAmount: "Récompenses / sanctions",
    incomeBoard: "Tableau revenus",
    dailyStats: "Statistiques quotidiennes",
    yesterdayFullDay: "Hier (journée)",
    platformIncomeTip: "Revenu total moins commissions livreurs sur la période",
    riderIncomeTip: "Revenu estimé de tous les livreurs sur la période",
    shopRechargeTip: "Total des recharges marchands sur la période",
    rewardTip: "Total récompenses / sanctions livreurs sur la période",
    dateCol: "Date",
    orderCountCol: "Commandes",
    revenueCol: "Chiffre d'affaires",
    platformIncomeCol: "Revenu plateforme",
    riderCommissionCol: "Commission livreurs",
    otherCol: "Autre",
    chartTime: "Heure : ",
    totalStack: "Total",
  },
  riderAsset: {
    title: "Actifs livreurs",
    pendingWithdraw: "En attente",
    withdrawn: "Retiré",
    frozen: "Gelé",
    withdrawApply: "Demandes de retrait",
    todayExpected: "Revenu estimé du jour",
    todayExpectedTip: "Montant des commandes valides sur la période",
    pendingWithdrawTip: "Retraits en attente de validation sur la période",
    withdrawnTip: "Montant déjà retiré sur la période",
    frozenTip: "Montant gelé avant cycle de retrait sur la période",
    riderNameCol: "Livreur",
    withdrawAmountCol: "Montant retrait",
    accountBalanceCol: "Solde",
    withdrawMethodCol: "Méthode",
    orderCountChart: "Commandes",
    riderExpectedChart: "Revenu livreur estimé",
  },
  shopAsset: {
    title: "Actifs marchands",
    recharge: "Recharge",
    consume: "Consommation",
    gift: "Bonus",
    rechargeBoard: "Tableau recharge",
    todayRecharge: "Recharge du jour",
    yesterdayRecharge: "Recharge d'hier",
    remainingRecharge: "Solde recharge restant",
    remainingTip: "Solde recharge actuel des marchands sur la période",
    consumeRecharge: "Recharge consommée",
    consumeTip: "Recharge consommée par envoi de commandes sur la période",
    giftRecharge: "Recharge offerte",
    giftTip: "Bonus offerts lors des recharges marchands",
    totalRecharge: "Recharge totale",
    totalTip: "Recharge + bonus de tous les marchands sur la période",
    shopStats: "Statistiques recharge",
    payAmountCol: "Paiement marchand",
    rechargeAmountCol: "Recharge marchand",
    orderCountCol: "Commandes",
    shopPayChart: "Dépenses marchands",
    shopRechargeChart: "Recharge marchands",
  },
  withdrawal: {
    listTitle: "Retraits",
    withdrawTime: "Date de retrait",
    riderName: "Livreur",
    withdrawMethod: "Méthode",
    withdrawAmount: "Montant (yuans)",
    fee: "Frais (yuans)",
    actualAmount: "Montant reçu (yuans)",
    status: "Statut",
    wechat: "WeChat",
    alipay: "Alipay",
    unionpay: "UnionPay",
    applying: "En cours",
    approved: "Approuvé",
    rejected: "Refusé",
    detail: "Détail",
    rider: "Livreur",
    payee: "QR code",
    bankCard: "N° carte",
    reservePhone: "Téléphone",
    bankName: "Banque",
    bankBranch: "Agence",
    actualMoneyLabel: "Montant net",
    pass: "Valider",
    reject: "Refuser",
  },
  withdrawalSettings: {
    title: "Paramètres retrait",
    enableWithdraw: "Activer les retraits",
    minAmount: "Montant minimum",
    feeRate: "Taux",
    fee: "Frais",
    interval: "Intervalle",
  },
};
